import { LowerCasePipe } from "@angular/common";
import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { NgbHighlight, NgbTypeahead } from "@ng-bootstrap/ng-bootstrap/typeahead";
import { debounceTime, distinctUntilChanged, map, Observable } from "rxjs";

import { StickyHeaderComponent } from "../../shared/sticky-header/sticky-header.component";
import { FleetSummaryComponent } from "../fleet-summary/fleet-summary.component";
import { ApiService } from "src/app/api.service";
import { FleetTrackerService } from "src/app/fleet-tracker.service";
import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-dashboard-default",
	templateUrl: "./dashboard-default.component.html",
	styleUrls: ["./dashboard-default.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [StickyHeaderComponent, NgbHighlight, FormsModule, NgbTypeahead, FleetSummaryComponent, RouterLink, LowerCasePipe]
})
export class DashboardDefaultComponent {
	private router = inject(Router);
	private fleettracker = inject(FleetTrackerService);
	public api = inject(ApiService);

	public fleets: APIResults.Fleet[];
	public orgs: APIResults.Organization[] = [];
	public brand = BrandVars;
	public searchText = "";
	private searchables = [];

	constructor() {
		this.fleettracker.fleets.pipe(takeUntilDestroyed()).subscribe(fleets => {
			this.orgs = [];
			// If fleets have orgs (admin) sort them by org
			if (fleets) {
				for (const fleet of fleets) {
					if (fleet.organization_id) {
						let fleetorg = this.orgs.find(item => item.organization_id === fleet.organization_id);
						if (!fleetorg) {
							fleetorg = { organization_id: fleet.organization_id, name: fleet.organization_name, fleets: [] };
							this.orgs.push(fleetorg);
						}
						fleetorg.fleets.push(fleet);
					}
				}
			}
			this.fleets = fleets;
			// Generate searchable entries
			this.searchables = [];
			if (fleets) {
				for (const fleet of fleets) {
					this.searchables.push({ category: "Fleet", url: "/dash/fleet/" + fleet.fleet_id, name: fleet.fleet_name });
					if (fleet.assets) {
						for (const asset of fleet.assets) {
							this.searchables.push({ category: "Asset", url: "/dash/fleet/" + fleet.fleet_id + "/asset/" + asset.asset_id, name: asset.asset_name, serial: asset.asset_serial_number, obcu: asset.obcu_serial_number });
						}
					}
				}
			}
		});
	}

	searchFunc = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			map(term => term.length < 2 ? []
				: this.searchables.filter(v => (v.name.toLowerCase().indexOf(term.toLowerCase()) > -1) || (v.serial && v.serial.toLowerCase().indexOf(term.toLowerCase()) > -1) || (v.obcu && v.obcu.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
		);

	searchNav = (searchable) => {
		this.router.navigate([searchable.url]);
	}

	getAssetCount(): number {
		return this.fleets?.reduce((acc, fleet) => acc + (fleet.assets ? fleet.assets.length : 0), 0) ?? 0;
	}
}
